<template>
  <h1 class="header">
    <div class="logo-wrap">
      <img class="logo" src="../../assets/image/ic_logo.webp">
      <span>{{ $t('title') }}</span>
    </div>
    <div v-if="logoutShown" class="logout-wrap" @click="logout">
      <a href="javascript:;">{{ $t('logout') }}</a>
    </div>
  </h1>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  props: {
    logoutShown: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    ...mapMutations([
      'setProfile'
    ]),
    async logout() {
      await this.setProfile()
      this.$router.replace({
        name: 'login',
        replace: true
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .header {
    font-family: 'SF UI Text Semibold';
    font-size: .32rem;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo-wrap {
      flex: 1;
      display: flex;
      align-items: center;

      .logo {
        width: .92rem;
        height: .92rem;
        vertical-align: middle;
      }
      span {
        margin: 0 .1rem;
      }
    }

    .logout-wrap {
      font-size: .28rem;
      background-color: rgba(1, 172, 255, .04);
      border-radius: .52rem;
      min-width: 1.2rem;
      text-align: center;
      height: .52rem;
      line-height: .52rem;
      padding: 0 .16rem;
      cursor: pointer;

      a {
        color: #01ACFF;
      }
    }
  }
</style>
